export const calcLastPage = (totalCount: number, pageSize: number, startPage = 0) => {
  if (totalCount === 0) {
    return startPage;
  }
  const fullPages = Math.floor(totalCount / pageSize);
  const restPage = totalCount % pageSize > 0 ? 1 : 0;
  const lastPage = fullPages + restPage;
  return startPage === 0 ? lastPage - 1 : lastPage;
};

export const calcCurrentPage = (currentFrom: number, pageSize: number, startPage = 0) => {
  if (currentFrom === 0) {
    return startPage;
  }
  const fullPages = Math.floor((currentFrom + 1) / pageSize);
  const restPage = (currentFrom + 1) % pageSize > 0 ? 1 : 0;
  const pageOffset = 1 - startPage;
  return fullPages + restPage - pageOffset;
};

const pageUtil = {
  calcCurrentPage,
  calcLastPage,
};
export default pageUtil;
